module.exports = __webpack_public_path__ + "static/media/1full.09152b17.jpg";